//const API_BASE_URL = "http://13.204.28.145:8001/"
//const API_BASE_URL = "https://api.rcubedev.tickbox.co.in/" DEVELOPMENT
const API_BASE_URL = "https://api.rcube.tickbox.co.in/"
export default API_BASE_URL
